/**
 * Single source of truth for the saved-search run lifecycle vocabulary.
 *
 * A run of a saved / smart-feed search (including TLDR previews) is inserted
 * PROCESSING, then closed out FINISHED (with its ordered results) or FAILED
 * (with an error). The backend owns these values in
 * `backend/app/queries/saved_search_run_status.py` (`SavedSearchRunStatus`,
 * `is_finished`, `is_failed`); this module is the frontend half of that same
 * wire contract. The union used to be re-typed across the repository and page
 * interfaces, and ReaderPage's poll loops compared bare `'FINISHED'` /
 * `'FAILED'` literals — a spelling drift on either side would leave a poll
 * loop spinning forever on a run the server considers closed. Route every
 * status comparison through `isRunFinished` / `isRunFailed` so each literal
 * lives in exactly one place.
 */
export type SavedSearchRunState = 'PROCESSING' | 'FINISHED' | 'FAILED';

/** True once a run committed its ordered results. */
export function isRunFinished(state: SavedSearchRunState): boolean {
  return state === 'FINISHED';
}

/** True once a run closed out with an unrecoverable error. */
export function isRunFailed(state: SavedSearchRunState): boolean {
  return state === 'FAILED';
}
